import { render, staticRenderFns } from "./CargoPersonDelivery.vue?vue&type=template&id=084e2c9c&"
import script from "./CargoPersonDelivery.vue?vue&type=script&lang=js&"
export * from "./CargoPersonDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports